export const enum PageBreakpoints {
  Desktop = 1264,
  Tablet = 960,
}
